import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Banknote, Lock, AlertTriangle } from 'lucide-react';
import { useTillStatus, fmtHours } from '../hooks/useTillStatus';

// Sticky red/amber reminder across the app: open the till (count the float), close yesterday's till, or close at end of day.
export const TillNudgeBanner = () => {
  const { status } = useTillStatus();
  const location = useLocation();
  if (!status || location.pathname === '/till') return null;

  const store = status.store_name;
  const copy = {
    needs_open: { tone: 'bg-red-600 hover:bg-red-700', icon: Banknote, text: `Till not opened at ${store} yet — have you counted your float? Opens ${fmtHours(status.hours?.open)}.`, cta: 'Open the till →' },
    stale: { tone: 'bg-red-700 hover:bg-red-800', icon: AlertTriangle, text: `${store}'s till from ${status.opened_on ? new Date(status.opened_on + 'T00:00:00').toLocaleDateString('en-NZ', { weekday: 'long', day: 'numeric', month: 'short' }) : 'a previous day'} was never closed — count that cash and close it before opening today.`, cta: 'Close it now →' },
    needs_close: { tone: 'bg-amber-500 hover:bg-amber-600 text-amber-950', icon: Lock, text: `${store} closes at ${fmtHours(status.hours?.close)} — count the cash and close the till.`, cta: 'Close the till →' },
  }[status.phase];
  if (!copy) return null;
  const Icon = copy.icon;

  return (
    <Link
      to="/till"
      className={`block sticky top-14 lg:top-0 z-30 ${copy.tone} text-white px-4 py-2.5 shadow-md transition-colors`}
      data-testid={`till-nudge-banner-${status.phase}`}
    >
      <div className="flex items-center justify-between gap-3 max-w-screen-2xl">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <Icon className="w-4 h-4 shrink-0 animate-pulse" />
          <span>{copy.text}</span>
        </div>
        <span className="text-xs underline whitespace-nowrap">{copy.cta}</span>
      </div>
    </Link>
  );
};
